/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");
import Vue from 'vue';

window.Vue = Vue;

// Vue Credit Card Validation
import VueCardFormat from 'vue-credit-card-validation';
Vue.use(VueCardFormat);

// Import Vee Validate
import VeeValidate from "vee-validate";
Vue.use(VeeValidate);

import {
    Validator
} from "vee-validate";
var err_msgs = require("./validation_err_msgs.js");
Validator.localize("en", err_msgs);

// custom validation to validate visa / master card
Validator.extend('visa_or_mastercard', {
    getMessage: (field) => 'We only accept Visa or Mastercard',
    validate: (value, params) => {
        return true;
        // return params[0] == 'visa' || params[0] == 'mastercard';
    }
});

// Load VueAxios for Vue Authenticate/Authorize
import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

// Load Store, Router and Auth
import store from "./store";
import router from "./router";

// Load Vue Modal
import SweetModal from "sweet-modal-vue/src/plugin.js";
Vue.use(SweetModal);

// Global Event Bus
Vue.prototype.$ebus = new Vue();

// Vue Multiselect
import Multiselect from "vue-multiselect";
Vue.component("multiselect", Multiselect);

// VTooltip
import VTooltip from "v-tooltip";
Vue.use(VTooltip);

// Animate css Vue2 Wrapper
require("vue2-animate/dist/vue2-animate.min.css");

// Used on Hamburger Icon for Mobile
import "vue-hamburger/index.css";
Vue.component("hamburger", require("vue-hamburger"));

// Used on Role Restrictions
import ToggleButton from "vue-js-toggle-button";
Vue.use(ToggleButton);

// Notifications Component
import VueNoty from "vuejs-noty";
Vue.use(VueNoty);

// Detect Breakpoints
import VueMq from "vue-mq";
Vue.use(VueMq, {
    breakpoints: {
        mobile: 640,
        tablet: 770,
        sm_desktop: 1024,
        lg_desktop: Infinity
    }
});

// Detect if element/component is hidden or not.
import VueObserveVisibility from "vue-observe-visibility";
Vue.use(VueObserveVisibility);

// Add Axios Interceptor
axios.interceptors.response.use(
    function (response) {
        // Do something with response data
        return response;
    },
    function (error) {
        if (error.response != undefined && error.response.status == 401) {
            window.location.href = "/auth-login";
        }
        return Promise.reject(error);
    }
);

import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

Sentry.init({
    Vue,

    dsn: process.env.MIX_SENTRY_DNS,

    integrations: [
        new Integrations.BrowserTracing({
            routingInstrumentation: Sentry.vueRouterInstrumentation(router),
            tracingOrigins: ["localhost", "my-site-url.com", /^\//],
        }),
    ],

    ignoreErrors: [
        'Request failed with status code 401',
        'Request failed with status code 502',
        'Request failed with status code 504',
        'Request failed with status code 522',
        'Request aborted'
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.001,
});

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.component("side-nav", require("./components/SideNav.vue").default);
Vue.component("static-side-nav", require("./components/StaticSideNav.vue").default);
Vue.component("main-app", require("./pages/MainApp.vue").default);
Vue.component("app-header", require("./components/AppHeader.vue").default);
Vue.component(
    "payment-method-banner",
    require("./components/PaymentMethodBanner.vue").default
);
Vue.component(
    "notification-center",
    require("./components/NotificationCenter.vue").default
);
Vue.component(
    "vault-settings-nav",
    require("./components/VaultSettingsNav.vue").default
);
Vue.component(
    "vault-settings-nav-mobile",
    require("./components/VaultSettingsNavMobile.vue").default
);

const app = new Vue({
    store,
    router,
    el: "#app",
});
